import produce from 'immer';
import { findIndex, includes, reject } from 'lodash/fp';
import * as actions from './actions';

export const initialState = {
  newsletters: { data: null, loading: false, error: null },
  targets: { data: null, loading: false, error: null },
  deletionTask: { data: null, loading: false, error: null },
};

const reducer = (state = initialState, action) => produce(state, (draft) => {
  switch (action.type) {
    case actions.FETCH_NEWSLETTERS_REQUEST:
      draft.newsletters.loading = true;
      break;
    case actions.FETCH_NEWSLETTERS_SUCCESS:
      draft.newsletters.loading = false;
      draft.newsletters.data = action.payload.newsletters;
      break;
    case actions.FETCH_NEWSLETTERS_FAILURE:
      draft.newsletters.loading = false;
      draft.newsletters.error = action.payload.error;
      break;
    case actions.FETCH_TARGETS_BY_NEWSLETTER_REQUEST:
      draft.targets.loading = true;
      break;
    case actions.FETCH_TARGETS_BY_NEWSLETTER_SUCCESS:
      draft.targets.loading = false;
      draft.targets.data = action.payload.targets;
      break;
    case actions.FETCH_TARGETS_BY_NEWSLETTER_FAILURE:
      draft.targets.loading = false;
      draft.targets.error = action.payload.error;
      break;
    case actions.DELETE_NEWSLETTERS_REQUEST:
      draft.deletionTask.loading = true;
      break;
    case actions.DELETE_NEWSLETTERS_SUCCESS:
      draft.deletionTask.loading = false;
      draft.deletionTask.data = true;
      draft.newsletters.data = reject(newsletter => includes(newsletter.id, action.payload.nids), draft.newsletters.data);
      break;
    case actions.DELETE_NEWSLETTERS_FAILURE:
      draft.deletionTask.loading = false;
      draft.deletionTask.error = action.payload.error;
      break;
    case actions.DELETE_NEWSLETTER_FILE_SUCCESS:
      break;
    case actions.DELETE_NEWSLETTER_FILE_FAILURE:
      draft.deletionTask.loading = false;
      draft.deletionTask.error = action.payload.error;
      break;
    case actions.INIT_DELETION_TASK:
      draft.deletionTask = { data: null, loading: false, error: null };
      break;
    case actions.CLEAR_DELETION_TASK_ERROR:
      draft.deletionTask.error = null;
      break;
    case actions.UPDATE_NEWSLETTERS:
      draft.newsletters.data[
        findIndex(
          newsletter => newsletter.id === action.payload.nid,
          draft.newsletters.data,
        )].lastSendAt = action.payload.lastSendAt;
      break;
    case actions.INIT_NEWSLETTERS:
      draft.newsletters = { data: null, loading: false, error: null };
      break;
    case actions.CLEAR_TARGETS_BY_NEWSLETTER_ERROR:
      draft.targets.error = null;
      break;
    case actions.INIT_TARGETS_BY_NEWSLETTER:
      draft.targets = { data: null, loading: false, error: null };
      break;
    default:
  }
});

export default reducer;
